// extracted by mini-css-extract-plugin
module.exports = {"separator":"Separator__separator__H5zNT","large":"Separator__large__36AjN"};